import { inject, Injectable } from '@angular/core';
import { DashboardProfileContextService } from '@rma/dashboard/authentication/public/user';
import { ImageType } from '@rma/dashboard/generic/orc/image-upload';
import { catchAndLogError } from '@rma/generic/rxjs/operators/catch-and-log-error';
import { map, Observable, of, switchMap, take as takeOperator } from 'rxjs';
import { ProfileThemeApiService } from '../api/profile-theme-api.service';
import { DEFAULT_PROFILE_BRANDING } from '../constants/default-branding';
import { ProfileBranding } from '../models/branding.models';
import { getImageConfigsProfileType } from '../models/theme-image-params';

@Injectable({
  providedIn: 'root',
})
export class ProfileThemeContextService {
  private readonly profileContext = inject(DashboardProfileContextService);
  private readonly profileThemeApiService = inject(ProfileThemeApiService);

  public imageConfigurations$ = this.profileContext.profileType$.pipe(map((profileType) => getImageConfigsProfileType(profileType)));

  public getBranding(): Observable<ProfileBranding> {
    return this.profileContext.profileIdentifier$.pipe(
      switchMap((pId) =>
        this.profileThemeApiService
          .getBranding(pId.profileType, pId.profileCode)
          .pipe(catchAndLogError<ProfileBranding>(of(DEFAULT_PROFILE_BRANDING))),
      ),
    );
  }

  public uploadImage(type: ImageType, fileName: string, isOriginal: boolean): Observable<Record<string, unknown>> {
    return this.profileContext.profileIdentifier$.pipe(
      switchMap((pId) => this.profileThemeApiService.uploadImage(pId.profileType, pId.profileCode, type, fileName, isOriginal)),
      takeOperator(1),
    );
  }

  public deleteImage(type: ImageType): Observable<Record<string, unknown>> {
    return this.profileContext.profileIdentifier$.pipe(
      switchMap((pId) => this.profileThemeApiService.deleteImage(pId.profileType, pId.profileCode, type)),
      takeOperator(1),
    );
  }

  public updateBrandKit(brandKitId: number): Observable<void> {
    return this.profileContext.profileIdentifier$.pipe(
      switchMap((pId) => this.profileThemeApiService.updateBrandKit(pId.profileType, pId.profileCode, brandKitId)),
      takeOperator(1),
    );
  }
}
